import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUpMdLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 12,4.25 c -0.191925,0 -0.3848,0.072305 -0.53125,0.21875 l -6,6 c -0.2928897,0.2929 -0.2928897,0.7696 0,1.0625 0.2928897,0.2929 0.7696103,0.2929 1.0625,0 L 11.25,6.8105469 V 19 c 0,0.4142 0.3358,0.75 0.75,0.75 0.4142,0 0.75,-0.3358 0.75,-0.75 V 6.8105469 l 4.71875,4.7207031 c 0.2929,0.2929 0.7696,0.2929 1.0625,0 0.2929,-0.2929 0.2929,-0.7696 0,-1.0625 l -6,-6 C 12.3848,4.3223051 12.191925,4.25 12,4.25 Z"
	})]
});
export default SvgArrowUpMdLine;
